import React, { lazy, Suspense } from 'react'; // Import lazy and Suspense
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// Remove react-universal-component import
// import universal from 'react-universal-component';
// Remove makeStyles if classes are not used
// import makeStyles from '@mui/styles/makeStyles';
import LoadingScreen from './LoadingScreen';
import ErrorScreen from './ErrorScreen'; // Keep ErrorScreen for potential fallback or manual error handling
// Remove isLoadingSelector as Suspense handles loading state
// import isLoadingSelector from '../selectors/isLoading';


// Remove useStyles if classes are not used in the component's render output
/*
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    height: '70vh',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progress: {
    margin: theme.spacing(2),
  },
}));
*/

// Remove isLoading prop as Suspense handles loading state
export const SwitcherComp = ({ location }) => {
  // Remove classes = useStyles(); if useStyles is removed
  // const classes = useStyles();
  const { routesMap, type } = location;
  const entry = routesMap[type];

  // Basic check for valid route entry
  if (!entry || !entry.component) {
    console.error(`Route entry or component path missing for type: ${type}`);
    // You might want a more sophisticated error display here
    return (
      <ErrorScreen
        message={`Route not found or misconfigured for type: ${type}`}
      />
    );
  }

  // Wrap the lazy component in Suspense
  // The fallback prop shows LoadingScreen while the component is loading
  return (
    <Suspense fallback={<LoadingScreen />}>
      {/* Render the dynamically imported lazy component */}
      <entry.component />
    </Suspense>
  );
};

SwitcherComp.propTypes = {
  // Remove isLoading propType
  location: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Remove UniversalComponent definition
/*
const UniversalComponent = universal(
  (props) => import(`../../${props.page}`).then((mod) => mod.default || mod),
  {
    minDelay: 0,
    chunkName: (props) => props.page,
    loading: () => <LoadingScreen />,
    error: (err) => {
      console.log(err);
      return <ErrorScreen />;
    },
  },
);
*/

const mapState = ({ location, ...state }) => ({
  location,
  // Remove isLoading from mapState as Suspense handles loading state
  // isLoading: isLoadingSelector({ ...state, location }),
});

const ConnectedSwitcher = connect(mapState)(SwitcherComp);

export default ConnectedSwitcher;